export default "__VITE_ASSET__CenBiAxB__"